import { useContext } from 'react';
import ProjectContext from 'src/contexts/ProjectContext';

const useProject = () => useContext(ProjectContext);

export default useProject;
